import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IhmPipesModule } from '../../shared/pipes/ihm-pipes.module';
import { IhmSelectAllCheckboxModule } from '../ihm-select-all-checkbox/ihm-select-all-checkbox.module';
import { IhmMultiSelectChipsListComponent } from './ihm-multi-select-chips-list.component';

@NgModule({
  imports: [
    CommonModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IhmPipesModule,
    MatSelectModule,
    IhmSelectAllCheckboxModule
  ],
  declarations: [IhmMultiSelectChipsListComponent],
  exports: [IhmMultiSelectChipsListComponent]
})
export class IhmMultiSelectChipsListModule {}
